import { SadmEntityFormType } from '@modules/sadm/models/sadm-entity-form-type';
import { SadmEntityChangesetPartialAction } from './sadm-entity-changeset-partial';
import { SadmEntityChangeset } from './sadm-entity-changeset';

export const changesetActionToGroupType = (action: SadmEntityChangesetPartialAction): SadmEntityFormType => {
  switch (action) {
    case 'creation':
      return 'creation';
    case 'protocol':
      return 'protocol';
    default:
      return 'analysis';
  }
};

export const sadmEntityChangesetFormTypes = (changeset: SadmEntityChangeset): readonly SadmEntityFormType[] => {
  const types: SadmEntityFormType[] = [];
  if (changeset.creationAnswer) {
    types.push('creation');
  }
  if (changeset.protocolAnswer) {
    types.push('protocol');
  }
  if (changeset.analysis) {
    types.push('analysis');
  }
  return types;
};
